export function safeParseJSON<T>(
  json: string | undefined | null,
  defaultValue: T
): T {
  if (!json) {
    return defaultValue;
  }

  try {
    return JSON.parse(json);
  } catch {
    return defaultValue;
  }
}
